import { useMemo } from "react";

import useStorage from "fe-shared/src/hooks/useStorage";
import {
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";
import { getRequestParams } from "../helpers/inventoryAdjustmentsRequestConverter";

const useInventoryAdjustmentsRequestParams = () => {
  const [options, setOptions] = useStorage<DataGridOptions>(
    "portalInventoryAdjustmentsOptions",
    {
      sortDirection: "desc",
      sortField: "completedDate",
    },
    true
  );
  const [filters, setFilters] = useStorage<DataGridFilters>(
    "portalInventoryAdjustmentsFilters",
    {},
    true
  );

  const requestParams = useMemo(() => getRequestParams(filters, options), [
    filters,
    options,
  ]);

  return {
    options,
    filters,
    setOptions,
    setFilters,
    requestParams,
  };
};

export default useInventoryAdjustmentsRequestParams;
